/** customerActivateByUrl — Shopify mutation to activate a customer account via the URL token from the activation email. */
import gql from 'graphql-tag';

export const customerActivateByUrl = gql`
mutation($activationUrl: URL!, $password: String!){
    customerActivateByUrl(
      activationUrl: $activationUrl,
      password: $password
    ) {
      customer { id }
      customerUserErrors { code field message }
    }
  } `;